import CssBaseline from '@mui/joy/CssBaseline'
import GlobalStyles from '@mui/joy/GlobalStyles'
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles'
import { PostHogProvider } from '@posthog/react'
import type { PropsWithChildren, ReactElement } from 'react'
import { IconContext } from 'react-icons'
import { Provider } from 'react-redux'

import { store } from '../store'
import { interFontFaces } from '../themes/interFontFaces'
import lightTheme from '../themes/light'
import posthog from './posthog'
import PostHogIdentify from './PostHogIdentify'

const Layout = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <PostHogProvider client={posthog}>
      <JoyCssVarsProvider theme={lightTheme}>
        <CssBaseline />
        <GlobalStyles styles={interFontFaces} />
        <GlobalStyles
          styles={{
            html: {
              height: '100%',
              width: '100%',
            },
            body: {
              height: '100%',
              width: '100%',
              background: 'var(--joy-palette-background-body)',
              '#app': {
                height: '100%',
                display: 'flex',
                overflow: 'auto',
                background: 'var(--joy-palette-background-level1)',
                '--Collapsed-breakpoint': '900px', // align with MUI md / useIsMobile
                '--Cover-width': '50vw', // must be `vw` only
                '--Form-maxWidth': '800px',
                '--Transition-duration': '0.4s', // set to `none` to disable transition
              },
            },
          }}
        />
        <IconContext.Provider value={{ color: 'text.icon', size: '1.25rem' }}>
          <Provider store={store}>
            <PostHogIdentify />
            {children}
          </Provider>
        </IconContext.Provider>
      </JoyCssVarsProvider>
    </PostHogProvider>
  )
}

export default Layout
